// src/hooks/useGamification.js - FIXED VERSION - Single Source Integration
import { useState, useEffect } from 'react';
import { auth } from '../firebase.js';
import gamificationService from '../services/gamificationService.js';
import enhancedUserService from '../services/enhancedUserService.js';

export const useGamification = () => {
  const [gameData, setGameData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadGameData = async () => {
      const user = auth.currentUser;
      if (user) {
        try {
          // Initialize game data fields if they don't exist
          await gamificationService.initializeUserGameData(user.uid);

          // Get game data (which now reads from the correct source)
          const data = await gamificationService.getUserGameData(user.uid);
          setGameData(data);
        } catch (error) {
          console.error('Error loading game data:', error);
          setError(error.message);
        }
      }
      setLoading(false);
    };

    loadGameData();
    const unsubscribe = auth.onAuthStateChanged(loadGameData);
    return unsubscribe;
  }, []);

  const awardXP = async (amount, category = 'grammar') => {
    const user = auth.currentUser;
    if (!user) return;

    try {
      // FIXED: The gamificationService.awardXP now automatically handles streak updates
      const updatedData = await gamificationService.awardXP(user.uid, amount, category);
      setGameData(updatedData);

      return { updatedData };
    } catch (error) {
      console.error('Error awarding XP:', error);
      setError(error.message);
    }
  };

  // FIXED: Remove updateStreak method - delegate to enhancedUserService
  // Components should use logDailyLogin from activityLogger instead
  const updateStreak = async () => {
    const user = auth.currentUser;
    if (!user) return;

    try {
      // Delegate to the single source of truth
      const newStreak = await enhancedUserService.updateStudyStreak(user.uid);

      if (newStreak !== null) {
        // Refresh game data to show updated streak
        const updatedData = await gamificationService.getUserGameData(user.uid);
        setGameData(updatedData);
        return newStreak;
      }
      return null;
    } catch (error) {
      console.error('Error updating streak:', error);
      setError(error.message);
      return null;
    }
  };

  // FIXED: Expose all necessary data with proper fallbacks
return {
  gameData,
  loading,
  error,
  awardXP,
  updateStreak,

  // Single source for streak
  dailyXP: gameData?.dailyXP || 0,
  totalXP: gameData?.totalXP || 0,
  studyStreak: gameData?.stats?.currentStreak || gameData?.studyStreak || 0,  // Always from stats.currentStreak
  achievements: gameData?.achievements || [],
  stats: gameData?.stats || {},

  // Keep these for compatibility
  longestStreak: gameData?.stats?.longestStreak || 0,
  currentStreak: gameData?.stats?.currentStreak || gameData?.studyStreak || 0,
};
};